import { iconClass } from 'src/app/enums/icon-class.enum';
import { RouteId } from 'src/app/enums/env/routes-id-enum';
import { RouteEnv } from 'src/app/interfaces/env/RouteEnv';

export const routeEnvironment: RouteEnv[] = [
    {
      id: RouteId.STATIONS,
      route: 'stations',
      name: 'menu.stations',
      icon: iconClass.STATIONS,
      detailBackLink: null,
      enabled: true,
      tabs: []
    },
    {
      id: RouteId.TERMINALS,
      route: 'terminals',
      name: 'menu.terminals',
      icon: iconClass.TERMINALS,
      detailBackLink: null,
      enabled: true,
      tabs: [
        {
          id: RouteId.TERMINALS_INFOS,
          route: 'informations',
          name: 'menu.informations',
          enabled: true,
          order: 1
        },
        {
          id: RouteId.TERMINALS_CONTACTS,
          route: 'contacts',
          name: 'menu.contact',
          enabled: true,
          order: 2
        },
      ]
    },
    {
      id: RouteId.CLIENTS,
      route: 'clients',
      name: 'menu.clients',
      icon: iconClass.CLIENTS,
      detailBackLink: null,
      enabled: true,
      tabs: [
        {
          id: RouteId.CLIENTS_INFOS,
          route: 'informations',
          name: 'menu.informations',
          enabled: true,
          order: 1
        },
        {
          id: RouteId.CLIENTS_CONTACTS,
          route: 'contacts',
          name: 'menu.contact',
          enabled: true,
          order: 2
        },
        {
          id: RouteId.CLIENTS_STATIONS,
          route: 'stations',
          name: 'menu.stations',
          enabled: true,
          order: 3
        },
        {
          id: RouteId.CLIENTS_CONTRATS,
          route: 'contrats',
          name: 'menu.contrats',
          enabled: true,
          order: 4
        },
      ]
    },
    {
      id: RouteId.CARRIERS,
      route: 'carriers',
      name: 'menu.carriers',
      icon: iconClass.CARRIERS,
      detailBackLink: null,
      enabled: true,
      tabs: [
        {
          id: RouteId.CARRIERS_INFOS,
          route: 'informations',
          name: 'menu.informations',
          enabled: true,
          order: 1
        },
        {
          id: RouteId.CARRIERS_CONTACTS,
          route: 'contacts',
          name: 'menu.contact',
          enabled: true,
          order: 2
        },
        {
          id: RouteId.CARRIERS_TERMINALS,
          route: 'terminals',
          name: 'menu.terminals',
          enabled: true,
          order: 3
        },
        {
          id: RouteId.CARRIERS_OPERATORS,
          route: 'operators',
          name: 'menu.exploit',
          enabled: true,
          order: 4
        },
        {
          id: RouteId.CARRIERS_DRIVERS,
          route: 'drivers',
          name: 'menu.drivers',
          enabled: true,
          order: 5
        },
        {
          id: RouteId.CARRIERS_VEHICLES,
          route: 'vehicles',
          name: 'menu.vehicles',
          enabled: true,
          order: 6
        },
        {
          id: RouteId.CARRIERS_CONTRATS,
          route: 'contrats',
          name: 'menu.contrats',
          enabled: true,
          order: 7
        },
      ]
    },
    {
      id: RouteId.USERS,
      route: 'users',
      name: 'menu.users',
      icon: iconClass.USERS,
      detailBackLink: null,
      enabled: true,
      tabs: [
        {
          id: RouteId.USERS_COLLABORATOR,
          route: 'collaborators',
          name: 'menu.collaborators',
          enabled: true,
          order: 1
        },
        {
          id: RouteId.USERS_DRIVER,
          route: 'drivers',
          name: 'menu.drivers',
          enabled: true,
          order: 1
        },
        {
          id: RouteId.USERS_EXPLOIT,
          route: 'exploit',
          name: 'menu.exploit',
          enabled: true,
          order: 1
        },
      ]
    },
    {
      id: RouteId.CONTRAT_CLIENT,
      route: 'contrat',
      name: 'menu.contrat',
      icon: iconClass.USERS,
      detailBackLink: null,
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.SETTINGS,
      route: 'settings',
      name: 'menu.settings',
      icon: iconClass.SETTINGS,
      detailBackLink: null,
      enabled: true,
      tabs: [
        {
          id: RouteId.SETTINGS_TICGN,
          route: 'ticgn',
          name: 'menu.TICGN',
          enabled: true,
          order: 1
        },
        {
          id: RouteId.SETTINGS_SECTION,
          route: 'section',
          name: 'menu.section',
          enabled: true,
          order: 2
        },
      ]
    },
    {
      id: RouteId.TANKS,
      route: 'tanks',
      name: 'menu.tanks',
      icon: iconClass.TANKS,
      detailBackLink: null,
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.DELIVERIES,
      route: 'deliveries',
      name: 'menu.deliveries',
      icon: iconClass.DELIVERIES,
      detailBackLink: null,
      enabled: true,
      tabs: []
    },
    {
      id: RouteId.PLANNING,
      route: 'planning',
      name: 'menu.planning',
      icon: iconClass.PLANNING,
      detailBackLink: null,
      enabled: true,
      tabs: []
    },
    {
      id: RouteId.PREINVOICE_CARRIER,
      route: 'preinvoices-carrier',
      name: 'menu.preinvoices-carrier',
      icon: iconClass.PREINVOICE_CARRIER,
      detailBackLink: null,
      enabled: true,
      tabs: []
    },
    {
      id: RouteId.CHARGES_SWAP,
      route: 'charges-swap',
      name: 'menu.charges-swap',
      icon: iconClass.CHARGES_SWAP,
      detailBackLink: null,
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.INVOICE,
      route: 'invoices',
      name: 'menu.invoices',
      icon: iconClass.INVOICE,
      detailBackLink: null,
      enabled: true,
      tabs: []
    },
    // ------------------------ //
    //          MOBILE          //
    // ------------------------ //
    {
      id: RouteId.MOBILE,
      route: 'mobile',
      name: '',
      icon: null,
      detailBackLink: null,
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.DRIVER_DAY,
      route: 'driver-day',
      name: '',
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.DRIVER_NEXT_WEEK,
      route: 'driver-next-week',
      name: '',
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.DRIVER_LAST_WEEK,
      route: 'driver-last-week',
      name: '',
      enabled: false,
      tabs: []
    },
    {
      id: RouteId.DRIVER_DELIVERY,
      route: 'driver-delivery/:uid',
      name: '',
      enabled: false,
      tabs: []
    },
  {
      id: RouteId.STATION_SAFETY_DOCUMENTS,
      route: 'delivery-safety-documents/:uid',
      name: 'menu.invoices',
      enabled: false,
      tabs: []
    },
];
